import React, { useRef } from 'react';
import propTypes from 'prop-types';
;
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import posed, { PoseGroup } from 'react-pose';
import { getFileInputValue } from '../util';
import { Field, Help } from 'src/ui/mui-ui-kit'

const HelperWrapper = posed.div({
  enter: {
    opacity: 1,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -10,
  },
});

export function UiFileUploader({
  id,
  value,
  name,
  errorMessage,
  label,
  required,
  hideAsterisk,
  hideHelper,
  onChange,
  ...rest
}) {
  const ref = useRef();
  const hasError = errorMessage ? 'danger' : '';
  const inputClassNames = classNames(
    'file has-name is-boxed is-medium is-centered',
    {
      'is-danger': hasError,
      'is-primary': !hasError,
    }
  );
  let fileName = value && value.name ? value.name : value;
  if (typeof value === 'string' && !value.length) {
    fileName = (
      <span className="has-text-grey-medium-dark">Select a file </span>
    );
  }
  const showAsterisk = required && !hideAsterisk;

  return (
    <Field className="ui-file-uploader">
      <div className={inputClassNames}>
        <label htmlFor={id}>
          <input
            type="file"
            className="file-input"
            name={name}
            id={id}
            required={required}
            ref={ref}
            accept="image/*,application/pdf"
            onChange={() => onChange(getFileInputValue(ref))}
            {...rest}
          />
          <span className="file-cta">
            <span className="file-icon">
              <FontAwesomeIcon icon={['fal', 'file-upload']} />
            </span>
            {label && <span className="file-label">{label}</span>}
          </span>
          <span className="file-name">
            {fileName}{' '}
            {showAsterisk && (
              <span className="icon is-small has-text-danger asterisk">
                <FontAwesomeIcon icon={['fas', 'asterisk']} size="xs" />
              </span>
            )}
          </span>
        </label>
      </div>
      {!hideHelper && (
        <div className="helper-wrapper">
          <PoseGroup>
            {errorMessage && (
              <HelperWrapper key="helper">
                <Help hasTextColor={hasError}>{errorMessage}</Help>
              </HelperWrapper>
            )}
          </PoseGroup>
        </div>
      )}
    </Field>
  );
}

UiFileUploader.defaultProps = {
  id: '',
  name: '',
  label: '',
  errorMessage: '',
  required: false,
  hideAsterisk: false,
  hideHelper: false,
};

UiFileUploader.propTypes = {
  id: propTypes.string,
  name: propTypes.string,
  label: propTypes.string,
  errorMessage: propTypes.string,
  required: propTypes.bool,
  value: propTypes.oneOfType([propTypes.object, propTypes.string]).isRequired,
  hideAsterisk: propTypes.bool,
  hideHelper: propTypes.bool,
  onChange: propTypes.func.isRequired,
};
